import React from 'react';
import { Link } from 'react-router-dom';
import { peacefulConvoPrintImg, vinylRoseImg, lavenderReverieImg, micahPortraitMain } from '../../data/products';
import './CategoryGrid.css';

const categories = [
  {
    label: 'Art',
    descriptor: 'Originals & Fine Art Prints',
    href: '/art',
    image: peacefulConvoPrintImg,
    alt: 'Original landscape painting by Micah Lynise',
  },
  {
    label: 'Fragrance',
    descriptor: 'Fine Natural Perfume',
    href: '/fragrance',
    image: vinylRoseImg,
    alt: 'Vinyl Rose Natural Perfume Oil by Micah Lynise',
  },
  {
    label: 'Body',
    descriptor: 'Oils & Butters',
    href: '/body',
    image: lavenderReverieImg,
    alt: 'Lavender Reverie Organic Whipped Shea Butter by Micah Lynise',
  },
  {
    label: 'Music',
    descriptor: 'Original Songs',
    href: '/music',
    image: micahPortraitMain,
    alt: 'Micah Lynise, artist and musician',
  },
];

const CategoryGrid: React.FC = () => (
  <section className="category-grid" aria-label="A world of creation">
    <div className="category-grid__inner container">
      <p className="category-grid__eyebrow">A World of Creation</p>
      <div className="category-grid__grid">
        {categories.map((cat) => (
          <Link key={cat.href} to={cat.href} className="category-card" aria-label={`${cat.label} — ${cat.descriptor}`}>
            <div className="category-card__image-wrap">
              <img
                src={cat.image}
                alt={cat.alt}
                className="category-card__image"
                width={320}
                height={220}
                loading="lazy"
              />
            </div>
            <div className="category-card__meta">
              <span className="category-card__label">{cat.label}</span>
              <span className="category-card__descriptor">{cat.descriptor}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default CategoryGrid;
